import { APICore } from "./apiCore";

const api = new APICore();
const baseUrl = `/web/withdraw-request`;

function getWithdrawsData(params: { status: string; page: number; limit: number }) {
  const { status, page, limit } = params;
  return api.get(`${baseUrl}`, { status, page, limit });
}

function updateWithdrawStatus(params: { id: string; status: string }) {
  return api.updatePatch(`${baseUrl}/${params.id}`, { status: params.status });
}

export { getWithdrawsData, updateWithdrawStatus };
